let config = {
   videoServerURL: "https://wpvidphonesec.tpvai.com/videophoneserver/",
   wsUrl : "wss://wpvidphonesec.tpvai.com/videophonews",
   iceservers: {
      "iceServers": [
        {
          "urls": [
            "stun:54.74.220.243:3478"
          ]
        },
        {
          "urls": [
            "turn:54.74.220.243:3478"
          ],
          "username": "videophone",
          "credential": "meetingdev"
        }
      ]
    },
    kurentoIceServers :
      [{"urls":"turn:54.74.220.243:3478","username":"videophone","credential":"meetingdev"}, {"urls":"stun:54.74.220.243:3478"}]

}


module.exports = config;
